<section class="px-4">
  <h2 mat-dialog-title>
    {{ data.id ? "Edit Component" : ("Add Component" | translatepipe) }}
  </h2>

  <div class="component-selection">
    <div class="cards-wrapper" role="list">
      <mat-card
        *ngFor="let comp of componentsList; let i = index"
        class="component-card card"
        [class.selected]="selectedComponent?.id === comp.id"
        (click)="selectComponent(comp)"
        (keydown.enter)="selectComponent(comp)"
        role="listitem"
        tabindex="0"
        [attr.aria-pressed]="selectedComponent?.id === comp.id"
      >
        <div class="image-container">
          <img
            [src]="getImageUrl(comp.image_url)"
            alt="{{ comp.name }}"
            class="image_styles"
            loading="lazy"
            (error)="onImageError($event)"
          />
          <div
            class="badge text_color"
            *ngIf="selectedComponent?.id === comp.id"
          >
            <mat-icon aria-hidden="true">check_circle</mat-icon>
            <span translate class="visually-hidden">Selected</span>
          </div>
        </div>
        <div class="content">
          <div class="title">{{ comp.name }}</div>
        </div>
      </mat-card>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="dialog-form">
    <div class="form-fields">
      <app-question
        *ngFor="let q of fromcontrols"
        [question]="q"
        [form]="form"
      ></app-question>

      <div class="dialog-actions">
        <button
          translate
          mat-stroked-button
          color="primary"
          type="button"
          (click)="onClose()"
        >
          Cancel
        </button>
        <button
          translate
          class="btn-color"
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="form.invalid"
        >
          {{
            data.pageId ? "Add Component" : ("Edit Component" | translatepipe)
          }}
        </button>
      </div>
    </div>
  </form>
</section>
